/** @jsxImportSource @emotion/react */
import { Button,Link, Icon} from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../../LanguageContext";

interface ProjectsHeaderProps {
   setNewProject: (set: boolean) => void;
   totalProjects: number;
}

export default function ProjectsHeader(props: Readonly<ProjectsHeaderProps>) {
  const theme = useTheme();
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const containerStyles = css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing["5xl"]};
  `;

  const mainContainerStyles = css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;

      > button {
        align-self: flex-end;
      }
    }
  `;

  const backButtonContainerStyles = css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing["lg"]};
    width: fit-content;
  `;

  const titleStyles = css`
    font-family: ${theme.typography.heading2_semiBold.fontFamily};
    font-size: ${theme.typography.heading2_semiBold.fontSize};
    font-weight: ${theme.typography.heading2_semiBold.fontWeight};
    line-height: ${theme.typography.heading2_semiBold.lineHeight};
    letter-spacing: ${theme.typography.heading2_semiBold.letterSpacing};
    color: ${theme.colors.textMedium};
  `;
    const linkStyles = css`
    font-family: ${theme.typography.body_semiBold.fontFamily};
    font-size: ${theme.typography.body_semiBold.fontSize};
    font-weight: ${theme.typography.body_semiBold.fontWeight};
    line-height: ${theme.typography.body_semiBold.lineHeight};
    text-decoration: none;
    color: ${theme.colors.primary};
    justify-content: center;
    align-items: flex-start;
    gap: ${theme.spacing.sm};
    cursor: pointer;
  `;
   const onClickProjects = () => {
    navigate(`/projects`);
  };
  return (
    <div css={containerStyles}>
       {location.pathname ==='/projects/new' && 
          <div css={backButtonContainerStyles}>
            <Link css={linkStyles}  onClick={onClickProjects}>
              <Icon name="arrow-narrow-left" size="xs" />
              {t("project_see_all")}
            </Link>
          </div>
      }
      <div css={mainContainerStyles}>
        <h2 css={titleStyles}>{t("toolbar_projects")}</h2>
        {location.pathname ==='/projects' && props?.totalProjects > 0 && 
        <Button
          variant={"brand"}
          icon={"plus"}
          color={theme.colors.primary}
          onClick={() => navigate('/projects/new')}
          className="brandPrimaryBtn"
        >
          {t("label_newProject")}
        </Button>
      }
      </div>
    </div>
  );
}
